import { Component, Injector, OnInit, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { JkBatchComponent } from 'jk-advcom';
import { idNameItem, JkBaseOption, jkRestReturnClass, MaterialModule, TitlebarComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

class Utyjb52Option extends JkBaseOption {
  ssmlText: string = `<speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="zh-TW">
    <p>
        <s>準備：</s>
        <s>找一個舒適的姿勢，讓身體得到完全的支撐。</s>
        <s>輕輕閉上眼睛，進行三次深長的呼吸。</s>
        <s><prosody rate="slow">吸氣時，想像吸入平靜；</prosody></s>
        <s><prosody rate="slow">呼氣時，想像呼出所有的壓力與緊繃。</prosody>
        <break time="3s"/>
    </p>
  </speak>
    `;
  outFile: string = './wav/test.mp3';
  colCount: number = 1;
  labelWidth: number = 100;
}

@Component({
  standalone: true,
  selector: 'app-utyjb52',
  templateUrl: './utyjb52.component.html',
  styleUrls: ['./utyjb52.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, JackBaseComponentModule, TitlebarComponent],
})
export class Utyjb52Component extends JkBatchComponent implements OnInit {
  override _programId = 'utyjb52';
  readonly titlebar = viewChild.required<TitlebarComponent>('titlebar');
  filterOpt: Utyjb52Option = new Utyjb52Option(this.programId);
  apiEndpoint: string = this.host + '/google/ssml-to-audio';

  constructor() {
    super();
    this.setFormOpt2();
    this.logMessage = '無錯誤訊息';
  }

  override async ngOnInit() {
    super.ngOnInit();
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.titlebar().onUser1Click = this.doSubmit;
    this.titlebar().user1Text = '執行';
    this.checkAllInit(this);
  }

  doClear() {
    this.filterOpt.ssmlText = '';
    this.filterOpt.outFile = '';
  }



  async doSubmit() {
    this.logMessage = '執行中...';
    let ssml = this.textToSsml(this.filterOpt.ssmlText);
    try {
      const body = {
        ssmlText: ssml,
        outFile: this.filterOpt.outFile,
      };
      //await this.http.post(this.apiEndpoint, body).toPromise();
      //let u = this.host + "/google/ssml-to-audio";
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // application/x-www-form-urlencoded
      this.http.post<jkRestReturnClass>(this.apiEndpoint, body, { headers: headers }).subscribe((ret) => {
        if (ret.result) {
          this.logMessage = '執行成功';
          this.showMessage('執行成功');
        } else {
          this.logMessage = `執行失敗: ${ret.errorLog}`;
          this.showAlertMat(ret.errorLog);
        }
      });
    } catch (error: any) {
      this.logMessage = `執行失敗: ${error.message}`;
      this.showAlertMat(error);
    }
  }
  textToSsml(rawLines: string) {
    // Replace special characters with HTML Ampersand Character Codes
    // These codes prevent the API from confusing text with SSML tags
    // For example, '<' --> '&lt;' and '&' --> '&amp;'
    let escapedLines = rawLines;
    escapedLines = escapedLines.replace(/&/g, '&amp;');
    escapedLines = escapedLines.replace(/"/g, '&quot;');
    escapedLines = escapedLines.replace(/</g, '&lt;');
    escapedLines = escapedLines.replace(/>/g, '&gt;');

    // Convert plaintext to SSML
    // Tag SSML so that there is a 2 second pause between each address
    //const expandedNewline = escapedLines.replace(/\n/g, '\n<break time="2s"/>');
    const ssml = escapedLines;

    // Return the concatenated String of SSML
    return ssml;
  }
}
